// 'use-strict'
import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { Switch, Route } from 'react-router-dom';
import {
  // AppBreadcrumb,
  AppFooter,
  AppSidebar,
  AppSidebarForm,
  AppSidebarHeader,
  AppHeader,
  AppSidebarNav,
} from '@coreui/react';

// Import Custom Component
import DefaultFooter from '../../../components/Footer/DefaultFooter';
import DefaultHeader from '../../../components/MenuBar/DefaultHeader';

import Page404 from '../Page404/Page404';
import Page500 from '../Page500/Page500';
import Page401 from '../Page401/Page401';
// import routes from '../routes';
import ReportSearch from '../../../Containers/Reports/Search';
import EditReport from '../../../Containers/Reports/Edit';
// import CsvExport from '../../../Containers/Reports/CsvExport';
// sidebar nav config
import navigation from '../../../components/NavBar/_nav';
import CsvExport from '../../../Containers/Reports/CsvExportDetails';
import PrefixScan from '../../../Containers/Reports/PrefixScan';

class Dashboard extends Component {
  /* eslint class-methods-use-this:0 */
  _routerWithProfile() {
    return (
      <Switch>
        <Route
          exact
          path="/reports/csv"
          name="Dashboard Page1"
          component={CsvExport}
        />
        <Route
          exact
          path="/reports/search"
          name="Dashboard Page3"
          component={ReportSearch}
        />
        <Route
          exact
          path="/reports/edit"
          name="Dashboard Page4"
          component={EditReport}
        />
        <Route
          exact
          path="/reports/prefixscan"
          name="Dashboard Page4"
          component={PrefixScan}
        />
        <Route
          exact
          path="/reports"
          name="Dashboard Page2"
          component={ReportSearch}
        />
        <Route path="/Page404" name="Page404" component={Page404} />
        <Route path="/Page500" name="Page500" component={Page500} />
        <Route path="/Page401" name="Page401" component={Page401} />
      </Switch>
    );
  }

  render() {
    return (
      <div className="app">
        <AppHeader fixed>
          <DefaultHeader />
        </AppHeader>
        <div className="app-body">
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            {/* <Suspense> */}
            <AppSidebarNav navConfig={navigation} {...this.props} />
            {/* </Suspense> */}
          </AppSidebar>
          <main className="main">
            {/* <AppBreadcrumb appRoutes={routes} /> */}
            <Container fluid>{this._routerWithProfile()}</Container>
          </main>
        </div>
        <AppFooter>
          <DefaultFooter />
        </AppFooter>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Pages/Dashboard/Dashboard.js